export default function AboutCTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-emerald-600 to-teal-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          プロジェクトについて<br />詳しく知りたい方へ
        </h2>
        <p className="text-xl text-emerald-50 mb-10 leading-relaxed">
          廃校活用プロジェクトや陸上養殖技術について、<br />
          さらに詳しい情報をご覧いただけます。
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/project"
            className="inline-flex items-center justify-center gap-2 bg-white text-emerald-600 px-8 py-4 rounded-lg font-semibold hover:bg-emerald-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span>廃校活用プロジェクト</span>
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="/technology"
            className="inline-flex items-center justify-center gap-2 bg-emerald-700 text-white px-8 py-4 rounded-lg font-semibold hover:bg-emerald-800 transition-colors border-2 border-white/20 whitespace-nowrap cursor-pointer"
          >
            <span>陸上養殖技術</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}